import { format } from 'date-fns';
import i18next from 'i18next';
import { Badge, Flex, Heading } from 'yoso';
import { NoticeModel } from '~/components/Support';
import { t } from '../I18n';
import './NoticeItem.scss';

export type NoticeItemProps = NoticeModel;

export const NoticeItem = ({
  title,
  originTitle,
  category = '',
  subCategory = '',
  newBadge,
  registered,
}: NoticeItemProps) => {
  const prefixXltKey = `citizen_notice_prefix_${subCategory + category}`;
  const prefix = `[${t(prefixXltKey)}]`;

  return (
    <Flex className="notice-item" container>
      <Flex className="notice-item-title-container" container flex={1}>
        <Heading level={6} className="notice-item-title">
          {i18next.exists(prefixXltKey) ? prefix + title : originTitle}
          <Badge variant="dot" color="primary" visible={newBadge} />
        </Heading>
      </Flex>
      <Flex className="notice-item-registered-container">
        <span className="notice-item-registered">{format(registered, 'PP')}</span>
      </Flex>
    </Flex>
  );
};
